import React from "react";
import "./App.css";
import {Dots} from 'react-preloaders';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./components/home";
import HomeAr from "./components/home_ar";
import PrivacyAr from "./components/privacy_ar";

import Privacy from "./components/privacy";

function App() {
  return (
    <div>

    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={Home}></Route>


          <Route path="/privacy" render={(props) => <Privacy {...props}  />} />


          <Route exact path="/privacy_ar" component={PrivacyAr}></Route>

          <Route exact path="/ar" component={HomeAr}></Route>

        </Switch>
      </Router>
    </div>
    <Dots time={2000} color={'#eb8025'}  background="#ffff" className="load" animation="slide" />
    </div>
  );
}

export default App;
